import { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import { TextField, Box, Paper } from "@mui/material";

import { toast } from "react-toastify";

import CustomButton from "../UI/CustomButton";
import useGenerateMessageMutation from "../../hooks/useGenerateMessageMutation";

export default function ChatForm({
  queryId,
  getQueryMessages,
  GetQueryData,
  isConversationClosed,
  fromUserId,
}) {
  const user_data = JSON.parse(localStorage.getItem("user_data"));

  const [message, setMessage] = useState("");

  const generateMessageMutation = useGenerateMessageMutation();

  const handleMessageQuery = (closed) => {
    if (!closed && message.length === 0) {
      toast.error("Write a message or Select Role for Generating a Query Message");
      return;
    }

    generateMessageMutation.mutate(
      {
        queryId: queryId,
        message: message,
        closed: closed,
      },
      {
        onSuccess: () => {
          getQueryMessages();
          GetQueryData();
          setMessage("");
        },
      }
    );
  };

  return (
    <Box component="div" sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Paper
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleMessageQuery(false);
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          gap: 1,
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "background.paper",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Write a message"
          fullWidth
          name="message"
          required
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={isConversationClosed}
          sx={{
            backgroundColor: "background.default",
            height: "100%",
          }}
          InputProps={{
            sx: {
              height: "42px",
            },
          }}
        />

        <CustomButton
          type="submit"
          disabled={isConversationClosed}
          endIcon={<SendIcon />}
          sx={{ height: "42px", minWidth: "120px" }}
        >
          Send
        </CustomButton>

        <CustomButton
          onClick={() => handleMessageQuery(true)}
          disabled={isConversationClosed || fromUserId !== user_data.id}
          sx={{ height: "42px", minWidth: "120px" }}
        >
          Close Query
        </CustomButton>
      </Paper>
    </Box>
  );
}
